import React from 'react';

const About = () => {
  return (
    <div className="min-h-screen pt-16 bg-[#1a1a1a]">
      {/* Hero Section */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 border-b border-gray-800">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-white mb-3 uppercase">
            About Me
          </h1>
          <p className="text-sm md:text-base text-gray-400 font-light tracking-wider uppercase">
            3D Character Modeler
          </p>
        </div>
      </section>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Biography with Photo */}
        <section className="bg-[#2a2a2a] border border-gray-800 p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
            {/* Profile Photo */}
            <div className="md:col-span-1">
              <div className="relative aspect-square overflow-hidden border-2 border-gray-700">
                <img
                  src="https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/zwuvl27w_image.png"
                  alt="Aaron W."
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Bio Text */}
            <div className="md:col-span-2 space-y-4">
              <h2 className="text-2xl font-bold text-white uppercase tracking-wide mb-4">Hello!</h2>
              <div className="space-y-4 text-base text-gray-300 leading-relaxed">
                <p>
                  As an aspiring 3D character modeler, my journey is fueled by a deep passion for digital artistry and storytelling. My toolbox includes software like Autodesk Maya for rigging and animation, Zbrush, and the Adobe Suite for texture painting and concept art.
                </p>
                <p>
                  As I continue looking ahead, my goal is to contribute to the gaming or animation industry. I envision collaborating with talented teams, shaping captivating worlds, and leaving an memorable mark on interactive experiences. As I continue my education and expand my portfolio, I remain committed to pushing boundaries, learning from fellow artists, and evolving as a 3D character modeler. Feel free to contact me using my email.
                </p>
                <p className="font-medium text-white">
                  I look forward to working with you.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
